// extracted by mini-css-extract-plugin
module.exports = {"cartItem":"CartItem_cartItem__3tLqB","quantity":"CartItem_quantity__256Bf","remove_item":"CartItem_remove_item__1qHCa"};